import "./Loading.css";

const Balls = () => (
    <div className="dots">
        <div></div>
        <div></div>
        <div></div>
    </div>
);

export default Balls;
